<div class="banner container-fluid">
  <div class="container" [ngSwitch]="riskCode" [ngClass]="{'banner-code-one':riskCode===1, 'banner-code-two':riskCode===2, 'banner-code-three':riskCode===3, 'banner-code-four':riskCode===4, 'banner-code-five':riskCode===5 }">
    <h5 class="title vg-heading-five" *ngSwitchCase="1">
      Risks associated with conservative funds
    </h5>
    <h5 class="title vg-heading-five" *ngSwitchCase="2">
      Risks associated with conservative to moderate funds
    </h5>
    <h5 class="title vg-heading-five" *ngSwitchCase="3">
      Risks associated with moderate funds
    </h5>
    <h5 class="title vg-heading-five" *ngSwitchCase="4">
      Risks associated with moderate to aggressive funds
    </h5>
    <h5 class="title vg-heading-five" *ngSwitchCase="5">
      Risks associated with aggressive funds
    </h5>
    <p class="vg-paragraph-one" [innerHTML]="levelDesc"></p>
  </div>
</div>